import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th, & td': {
      padding: '10px 5px',
      textAlign: 'center',
      border: `1px solid ${theme.custom.gray200}`,
      fontSize: '0.875em',
      verticalAlign: 'top',
      color: theme.custom.gray500,
    },
  },
  brandPosition: {
    display: 'inline-flex',
    alignItems: 'center',
    '&:not(:last-child)': {
      marginBottom: '5px',
    },
    '& img': {
      marginRight: '5px',
    },
  },
}));

const Animals = () => {
  const classes = useStyles();

  return (
    <div>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>Animal</th>
            <th>Head</th>
            <th>Brand</th>
            <th>Gender</th>
            <th>Breed</th>
            <th>Beef Council Fee</th>
            <th>Predator Control Fee</th>
            <th>Inspection Fee</th>
            <th>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Cattle</td>
            <td>1</td>
            <td style={{ maxWidth: '150px' }}>
              <label className={classes.brandPosition}>
                <img src="https://via.placeholder.com/35" alt="Right hip" />
                <span>Right Hip</span>
              </label>
              <label className={classes.brandPosition}>
                <img src="https://via.placeholder.com/35" alt="Right hip" />
                <span>Left Shoulder</span>
              </label>
              <label className={classes.brandPosition}>
                <img src="https://via.placeholder.com/35" alt="Right hip" />
                <span>Right Shoulder</span>
              </label>
            </td>
            <td>Bull</td>
            <td>Charolais</td>
            <td>$3.00</td>
            <td>$0.50</td>
            <td>$61.00</td>
            <td>$64.50</td>
          </tr>
          <tr>
            <td>Cattle</td>
            <td>1</td>
            <td>
              <label className={classes.brandPosition}>
                <img src="https://via.placeholder.com/35" alt="Right hip" />
                <span>Right Hip</span>
              </label>
            </td>
            <td>Bull</td>
            <td>Charolais</td>
            <td>$3.00</td>
            <td>$0.50</td>
            <td>$61.00</td>
            <td>$64.50</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Animals;
